var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotStar5New = function SvgTrustpilotStar5New(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trustpilotStar5New_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.43 10 12 2l-2.43 8H2l6.18 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.57Z",
    fill: "#00A550"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trustpilotStar5New_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.43 10 36 2l-2.43 8H26l6.18 4.41L29.83 22 36 17.31 42.18 22l-2.35-7.59L46 10h-7.57Z",
    fill: "#00A550"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trustpilotStar5New_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.43 10 60 2l-2.43 8H50l6.18 4.41L53.83 22 60 17.31 66.18 22l-2.35-7.59L70 10h-7.57Z",
    fill: "#00A550"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trustpilotStar5New_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.43 10 84 2l-2.43 8H74l6.18 4.41L77.83 22 84 17.31 90.18 22l-2.35-7.59L94 10h-7.57Z",
    fill: "#00A550"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#trustpilotStar5New_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.43 10 108 2l-2.43 8H98l6.18 4.41-2.35 7.59 6.17-4.69 6.18 4.69-2.35-7.59L118 10h-7.57Z",
    fill: "#00A550"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "trustpilotStar5New_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trustpilotStar5New_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(24)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trustpilotStar5New_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(48)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trustpilotStar5New_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(72)",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "trustpilotStar5New_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(96)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTrustpilotStar5New;